export default {
	getMonitorId: '/site-test-tool/start', // 开始检测 获取检测ID
	getMonitorResults: '/site-test-tool/results/{id}', //获取检测结果
	getMonitorMyResults: '/site-test-tool/my-site-report', // 获取我的网站报告

  getAliMonitor: '/ali/monitor/list',  //获取阿里监控状态

  siteTestToolCountry: '/site-test-tool/country', // 国家-计数
};
